import React from 'react';
import { TPropertiesOfPatchChangesForModGroup } from 'types';
import { Checkbox } from 'antd';
import Text from 'components/Text/Text';
import style from './DisabledStatus.module.scss';

interface IProps {
	toggleForceDisable(): void;
	selectedProperties: TPropertiesOfPatchChangesForModGroup[];
	forceDisable: boolean;
}

export const DisabledStatus: React.FC<IProps> = ({ toggleForceDisable, selectedProperties, forceDisable }) => {
	return (
		<div className={style.container}>
			{selectedProperties.includes('forceDisable') && (
				<div className={style.row}>
					<div className={style.input}>
						<Text translationNameSpace="form" translationKey="disabledStatusHeading" size="xs" />
						<Checkbox onChange={toggleForceDisable} checked={forceDisable}>
							<Text translationNameSpace="form" translationKey="isForceDisabledLabel" asFragment={true} />
						</Checkbox>
					</div>
				</div>
			)}
		</div>
	);
};
